import { dataHourglass } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHourglass = /*#__PURE__*/createIcon(dataHourglass)
export default IconHourglass
